import React from 'react';
import styled from 'styled-components';
import { formatNumberWithCommas } from 'Utils/UtilityFunctions';
import {
  boxShadow, maxWidth, primaryColor, primaryFont, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';

const Overlay = styled.div`
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 17px 24px;
  height: 87px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media all and (max-width: ${maxWidth}) , ${retina} {
   padding: 10px 15px; 
  }
  .stats {
    .download-profile {
     font-family: ${primaryFont};
     font-size: 18px;
     color: ${primaryColor};
     margin-bottom: 5px;
     letter-spacing: -0.38px;
     line-height: 24px;
     font-weight: ${wMedium};
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      margin-bottom: 0px;
     }
    }
    .unique {
     color: #3F4B50;
     font-size: 14px;
     line-height: 24px;
     letter-spacing: -0.29px;
     font-family: ${primaryFont};
     font-weight: ${wMedium};
    }
  }
  .total {
   font-family: ${secondaryFont};
   font-size: 20px;
   letter-spacing: -0.38px;
   color: ${primaryColor};
   @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
   }
  }
`;

type Props = {
  downloadProfile: number,
  uniqueView: number,
  totalView: number,
  articleShare: number,
  hideDownloads: boolean,
  isArticle: boolean,
} | typeof defaultProps;

const defaultProps = {
  downloadProfile: 0,
  uniqueView: 0,
  totalView: 0,
  articleShare: 0,
  hideDownloads: false,
  isArticle: false,
};

const EngagementProfileStats = function EngagementProfileStats(props: Props) {
  const {
    downloadProfile, uniqueView, totalView, articleShare, hideDownloads, isArticle,
  } = props;
  const formattedDownloadsProfile = formatNumberWithCommas(downloadProfile);
  const formattedArticleShare = formatNumberWithCommas(articleShare);
  const formattedUniqueView = formatNumberWithCommas(uniqueView);
  const formattedTotalView = formatNumberWithCommas(totalView);

  return (
    <Overlay>
      <div className="stats">
        {!hideDownloads && <h6 className="download-profile">{`Profile Downloads: ${formattedDownloadsProfile}`}</h6>}
        {isArticle
          ? <span className="unique">{`Article Shared: ${formattedArticleShare}`}</span>
          : <span className="unique">{`Unique Views: ${formattedUniqueView}`}</span>}
      </div>
      <div className="total">{formattedTotalView}</div>
    </Overlay>
  );
};

EngagementProfileStats.defaultProps = defaultProps;
export default EngagementProfileStats;
